import React from 'react';
import FontAwesome from 'react-fontawesome';
import {
    Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger, Radio,
    Tooltip
} from "react-bootstrap";

export default class QuestionForm extends React.Component {
    render() {
        let questionIndex = this.props.index;
        let question = this.props.data;
        let answers = question.answers;
        let validation = this.props.validation;
        let {messages, states} = validation;
        let {
            handleAddAnswer,
            handleRemoveAnswer,
            handleChangeQuestionText,
            handleChangeQuestionExplanation,
            handleChangeQuestionTimeframe,
            handleChangeAnswerText,
            handleChangeAnswerCorrectness,
        } = this.props.handles;

        const tooltipRemoveAnswer = <Tooltip id="tooltipRemoveAnswer">Odstranít odpověď</Tooltip>;

        return (
            <div>
                <div className="row">
                    <div className="col-lg-5">
                        <h2>Základní údaje</h2>
                        <FormGroup controlId="text" validationState={states.text}>
                            <ControlLabel>Znění <span className="required">*</span></ControlLabel>
                            <FormControl componentClass="textarea"
                                         value={question.text}
                                         //disabled={question.used}
                                         onChange={(event) => handleChangeQuestionText(event, questionIndex)}/>
                            <FormControl.Feedback/>
                            <HelpBlock>{messages.text}</HelpBlock>
                        </FormGroup>
                        <FormGroup controlId="explanation" validationState={states.explanation}>
                            <ControlLabel>Vysvětlení <span className="required">*</span></ControlLabel>
                            <FormControl componentClass="textarea"
                                         value={question.explanation}
                                         //disabled={question.used}
                                         onChange={(event) => handleChangeQuestionExplanation(event, questionIndex)}/>
                            <FormControl.Feedback/>
                            <HelpBlock>{messages.explanation}</HelpBlock>
                        </FormGroup>
                        <FormGroup controlId="timeframe" validationState={states.timeframe}>
                            <ControlLabel>Časová náročnost <span className="required">*</span></ControlLabel>
                            <FormControl type="number"
                                         value={question.timeframe}
                                         //disabled={question.used}
                                         onChange={(event) => handleChangeQuestionTimeframe(event, questionIndex)}/>
                            <FormControl.Feedback/>
                            <HelpBlock>{messages.timeframe}</HelpBlock>
                        </FormGroup>
                    </div>
                    <div className="col-lg-offset-1 col-lg-5">
                        <Form componentClass="fieldset" horizontal>
                            <h2>Odpovědi</h2>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Odpověď <span className="required">*</span></th>
                                    <th>Správná odpověď</th>
                                    <th/>
                                </tr>
                                </thead>
                                <tbody>
                                {[...answers].map((answer, index) => {
                                        let answerStates = states.answers[index];
                                        let answerMessages = messages.answers[index];
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <FormGroup controlId="answerText" validationState={answerStates.text}>
                                                        <FormControl
                                                            type="text" value={answer.text}
                                                            //disabled={question.used}
                                                            onChange={(event) => handleChangeAnswerText(event, questionIndex, index)}/>
                                                        <FormControl.Feedback/>
                                                        <HelpBlock>{answerMessages.text}</HelpBlock>
                                                    </FormGroup>
                                                </td>
                                                <td>
                                                    <Radio checked={answer.correctness}
                                                           //disabled={question.used}
                                                           onChange={(event) => handleChangeAnswerCorrectness(event, questionIndex, index)}/>
                                                </td>
                                                <td>
                                                    {
                                                        //!question.used &&
                                                        <OverlayTrigger placement="top" overlay={tooltipRemoveAnswer}>
                                                            <FontAwesome name="trash" size="2x"
                                                                         onClick={() => handleRemoveAnswer(questionIndex, index)}
                                                                         className="cursor-p"
                                                            />
                                                        </OverlayTrigger>
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                                </tbody>
                            </table>
                            <Button type="button" className="btn btn-success" onClick={() => handleAddAnswer(questionIndex)}>
                                Přidat odpověď
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/Specials/QuestionForm.js
 **/